export default function requestUserData() {
    return {
        type: requestUserData.type,
    };
}

requestUserData.type = 'REQUEST_USER_DATA';
